"use client";
import { use } from 'react';
import { SocketContext } from '../providers/socket-provider.js';
/**
 * Raw socket hook
 *
 * If you want to interact with /chat or /contacts websockets,
 * use **useChat** or **useContacts** instead.
 *
 */
export const useSocket = () => {
    const context = use(SocketContext);
    if (!context) {
        throw new Error('useSocket must be used within SocketProvider');
    }
    return {
        socket: context.socket,
        uri: context.uri,
        emit: (event, data) => context.socket?.emit(event, data),
        on: (event, callback) => context.socket?.on(event, callback),
        off: (event, callback) => context.socket?.off(event, callback),
    };
};
